
import { assistanceStackKey, dashboardStackKey, libraryStackKey, healthStackKey as profileStackKey, settingStackKey } from '../../constants/routeKeys';
import { useStores } from '../useStores';

export type userDrawerLabelPropsKey = (typeof dashboardStackKey) | (typeof libraryStackKey) | (typeof assistanceStackKey) | (typeof profileStackKey) | (typeof settingStackKey);

export const useDrawerLabel = (key: userDrawerLabelPropsKey) => {
  const {language} = useStores();
  const labels = language?.translate?.MOBILE;

  const getStackLabels = {
    [dashboardStackKey]: (labels?.DASHBOARD?.NAVIGATION_TITLE || 'Dashboard') as string,
    [libraryStackKey]: (labels?.LIBRARY?.NAVIGATION_TITLE || 'Library') as string,
    [assistanceStackKey]: (labels?.ASSISTANCE?.NAVIGATION_TITLE || 'Assistance') as string,
    [profileStackKey]: (labels?.HEALTH?.NAVIGATION_TITLE || 'Health') as string,
    [settingStackKey]: (labels?.SETTINGS?.NAVIGATION_TITLE || 'Settings') as string
  };

  return getStackLabels[key];
};